<template>
    <el-menu router>
        <el-menu-item index="/wsjsys/entity" v-if="validPriv('0020001')">
            <span class="menu-icon icon-entity"></span>
            <template #title>实体管理</template>
        </el-menu-item>
        <el-menu-item index="/wsjsys/device" v-if="validPriv('0020006')">
            <span class="menu-icon icon-passenger"></span>
            <template #title>设备管理</template>
        </el-menu-item>
        <el-menu-item index="/wsjsys/role" v-if="validPriv('0020003')">
            <span class="menu-icon icon-role"></span>
            <template #title>角色管理</template>
        </el-menu-item>
        <el-menu-item index="/wsjsys/user" v-if="validPriv('0020002')">
            <span class="menu-icon icon-account"></span>
            <template #title>用户管理</template>
        </el-menu-item>
        <el-menu-item index="/wsjsys/biz-model" v-if="validPriv('0020005')">
            <span class="menu-icon icon-role"></span>
            <template #title>业态管理</template>
        </el-menu-item>
        <el-menu-item index="/wsjsys/log" v-if="validPriv('0020007')">
            <span class="menu-icon icon-log"></span>
            <template #title>用户日志</template>
        </el-menu-item>
    </el-menu>
</template>
<script>
export default {
    methods: {
        validPriv(code) {
            return this.$auth.validPrivCode(code);
        },
    },
};
</script>
